import { MonthlyUserPlanningDay } from "./MonthlyUserPlanningDay";
import { dateToAAAAMMJJ, dateWithoutHour, intToDay, firstLetterCapital } from "../../functions";

const MonthlyUserPlanning = (props) => {
    const { startDate, endDate, planning, selectedTimeSlots, publicHolidays } = props;

    const mupStartDate = dateWithoutHour(startDate);
    const mupEndDate = dateWithoutHour(endDate);

    function handleClickDate(val, ctrlKey) {
        props.onClickDate(val, ctrlKey);
    };

    function handleClickTimeSlots(tsId, ctrlKey) {
        props.onClickTimeSlots(tsId, ctrlKey);
    };

    const planningWithDate = () => {
        let aDate = dateWithoutHour(mupStartDate);
        let arrayOfDate = [];
        while (aDate <= mupEndDate) {
            arrayOfDate.push(dateWithoutHour(aDate));
            aDate.setDate(aDate.getDate() + 1);
        }
        const aResult = arrayOfDate.map((aDate) => {
            const aDay = {
                datePlanning: dateWithoutHour(aDate),
                timeSlots: planning && planning.filter((pl) => {
                    return (dateWithoutHour(pl.start_date).toDateString() == dateWithoutHour(aDate).toDateString())
                }),
            }
            return aDay;
        })
        return aResult;
    }

    const columns = [...new Array(7)].map((val, index) => (index + 1) % 7);

    const isPublicHoliday = (date) => {
        return publicHolidays.some(holiday => holiday.date == dateToAAAAMMJJ(date, "-"));
    }

    const render = (
        <div className="m-0 text-xs">
            <div className="w-full p-0 flex m-1">
                <div className="w-full flex bg-slate-100 border-t border-l border-b">
                    {columns.map((day, index) =>
                        <div key={index} className={"w-[14.28571%] border-r flex py-1 justify-center"}>
                            {firstLetterCapital(intToDay(day))}
                        </div>
                    )}
                </div>
            </div>
            <div className="w-full p-0 flex flex-wrap m-1 border-t border-l">
                {planningWithDate().map((day) => (
                    <div key={day.datePlanning} className="w-[14.28571%] flex flex-wrap border-b border-r justify-center h-28">
                        <MonthlyUserPlanningDay
                            datePlanning={day.datePlanning}
                            timeSlots={day.timeSlots}
                            onClickDate={handleClickDate}
                            onClickTimeSlots={handleClickTimeSlots}
                            selectedTimeSlots={selectedTimeSlots}
                            isPublicHoliday={isPublicHoliday(day.datePlanning)}
                        />
                    </div>

                ))
                }
            </div>
        </div>
    )

    return render;
};

export default MonthlyUserPlanning;